import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import UploadRouteControl from "./UploadRouteControl";
import { clearDraftRoute, addDraftRouteMapPoints, setReCentreOnMapLoad } from "../../redux/actions/routeActions";
import { setupNavigation } from "../../redux/actions/navItemsActions";
import Spinner from "../common/Spinner";


function UploadRoutePage({
    clearDraftRoute,
    addDraftRouteMapPoints,
    setReCentreOnMapLoad,
    setupNavigation,
    history
}) {

    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        document.title = "Upload Route | JustGoRide";
        setupNavigation({ sections: [] });
    }, []);

    function onUpload(route) {
        clearDraftRoute();
        addDraftRouteMapPoints(route);
        setReCentreOnMapLoad(true);
        history.push("/routes/create");
    }

    return (
        <div className="container">
            {processing ?
                <Spinner /> :
                (
                    <div className="row justify-content-md-center">
                        <div className="col-6  mt-5">
                            <h2>Upload a Route</h2>
                            <p>
                                Select a GPX file to upload. Once uploaded you will be redirected to
                                the Route Creator to make any changes prior to saving your route. 
                            </p>
                            <UploadRouteControl onUpload={onUpload} />
                        </div>
                    </div>
                )
            }
        </div>
    );

}

UploadRoutePage.propTypes =
    {
        clearDraftRoute: PropTypes.func.isRequired,
        addDraftRouteMapPoints: PropTypes.func.isRequired,
        setReCentreOnMapLoad: PropTypes.func.isRequired,
        setupNavigation: PropTypes.func.isRequired
    }


function mapStateToProps(state) {
    return {
    };
}

const mapDispatchToProps = {
    clearDraftRoute,
    addDraftRouteMapPoints,
    setReCentreOnMapLoad,
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadRoutePage); 


// WEBPACK FOOTER //
// ./src/components/routes/UploadRoutePage.js